<template>
  <ul class="p-coupon-list">
    <li
      v-for="(item, i) in list.slice(0, 3)"
      :key="i"
      @click="couponClicked(item)"
    >
      <coupon-item :name="couponText(item)"></coupon-item>
    </li>
  </ul>
</template>
<script>
import B_COUPON from '@/business/coupon'
import CouponItem from '../item'
export default {
  props: {
    list: Array,
    showName: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CouponItem
  },
  methods: {
    couponText(couponInfo) {
      if (this.showName) return couponInfo.couponName
      return B_COUPON.getCouponText(couponInfo)
    },
    couponClicked(item) {
      this.$emit('couponClicked', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.p-coupon-list {
  height: inherit;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  // background-color: lawngreen;
  li {
    height: inherit;
    display: flex;
    align-items: center;
    margin-right: 0.12rem;
    // background-color:khaki;
    &:nth-child(3) {
      margin-right: 0;
    }
  }
}
</style>
